/* eslint-disable import/prefer-default-export */
export const slugify = (source, separator) => {
  let result = source
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes
    .replace(/^-+/, '') // trim - from start of text
    .replace(/-+$/, ''); // trim - from end of text

  if (separator) {
    result = result.replace(/-/g, separator);
  }

  return result;
};

export const getEmptyStringIfFalsy = text => text ?? '';
